var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgScale = ({
  title,
  titleId,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  "data-testid": "scale-icon",
  width: "1em",
  height: "1em",
  viewBox: "0 0 15.635 13.6",
  xmlns: "http://www.w3.org/2000/svg",
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M7.818 2.8v9.6M5.318 12.8h5M2.494 4.8H13.14M2.494 4.8.8 8.526a2.597 2.597 0 0 0 3.388 0L2.494 4.8ZM13.141 4.8l1.694 3.726a2.597 2.597 0 0 1-3.388 0L13.142 4.8ZM7.818 2.6a.9.9 0 1 0 0-1.8.9.9 0 0 0 0 1.8Z"
}))));
export default SvgScale;